<template>
    <div>
        <h2>Modification information de l'atelier</h2>

        <div class="row">
            <div class="mb-3 col-md-6">
                <label for="nom_atelier" class="form-label fw-bold">Nom*</label>
                <input type="text" class="form-control" id="nom_atelier" placeholder="Nom du client"
                    v-model="formData.name" required>
                <small class="text-danger" v-if="errors['name']">{{ errors['name'][0] }}</small>
            </div>
            <div class="mb-3 col-md-6">
                <label for="phone_atelier" class="form-label fw-bold">Phone</label>
                <input type="phone" class="form-control" id="phone_atelier" placeholder="Nom du client"
                    v-model="formData.phone">
                <small class="text-danger" v-if="errors['phone']">{{ errors['phone'][0] }}</small>
            </div>
            <div class="mb-3 col-md-6">
                <label for="address_atelier" class="form-label fw-bold">Adresse</label>
                <input type="text" class="form-control" id="address_atelier" placeholder="Adresse"
                    v-model="formData.address">
                <small class="text-danger" v-if="errors['address']">{{ errors['address'][0] }}</small>
            </div>
            <div class="mb-3 col-md-6">
                <label for="city_client" class="form-label fw-bold">Ville</label>
                <input type="text" class="form-control" id="city_client" placeholder="Abidjan..."
                    v-model="formData.city">
                <small class="text-danger" v-if="errors['city']">{{ errors['city'][0] }}</small>
            </div>
            <div class="mb-3 col-md-6">
                <label for="website_atelier" class="form-label fw-bold">Website</label>
                <input type="text" class="form-control" id="website_atelier" placeholder="Site web"
                    v-model="formData.website">
                <small class="text-danger" v-if="errors['website']">{{ errors['website'][0] }}</small>
            </div>
            <div class="mb-3 col-md-6">
                <label for="facebook" class="form-label fw-bold">Facebook</label>
                <input type="text" class="form-control" id="facebook" placeholder="Page facebook"
                    v-model="formData.facebook">
                <small class="text-danger" v-if="errors['facebook']">{{ errors['facebook'][0] }}</small>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-end">
                <button class="btn btn-primary" @click="save">
                    Enregistrer
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';
export default {
    name: 'AtelierForm',
    mixins: [formMixin],
    data(){
        return {
            url:'/ateliers'
        }
    },
}
</script>